import { toast } from "react-hot-toast";
import i18n from "@/i18n/config";

export interface ApiError {
  response?: {
    data?: {
      message?: string;
      code?: string;
      error?: string | { message?: string };
    };
    status?: number;
  };
  message?: string;
}

export const handleApiError = (error: ApiError, customMessage?: string): string => {
  let errorMessage = customMessage || i18n.t("common:errors.generic");

  if (error.response?.data?.message) {
    errorMessage = error.response.data.message;
  } else if (error.response?.data?.error) {
    const errData = error.response.data.error;
    errorMessage =
      typeof errData === "string" ? errData : (errData.message ?? errorMessage);
  } else if (error.message) {
    errorMessage = error.message;
  }

  // Don't show toast for auth errors (handled by useAuth)
  if (error.response?.status === 401) {
    return errorMessage;
  }

  // Show different toast types based on error status
  if (error.response?.status === 400) {
    toast.error(errorMessage);
  } else if (error.response?.status === 403) {
    const message =
      error.response.data?.code === "PUBLIC_VISIBILITY_NOT_ALLOWED"
        ? // The backend sends a localized, action-neutral message; the local
          // string is only a fallback, since the same code is returned from
          // both event creation and update.
          (error.response.data?.message ??
            i18n.t("events:validation.publicVisibilityNotAllowed"))
        : i18n.t("common:errors.accessDenied");
    toast(message, {
      icon: "⚠️",
      style: {
        background: "#FEF3C7",
        color: "#92400E",
        border: "1px solid #FBBF24",
      },
    });
  } else if (error.response?.status === 404) {
    toast.error(i18n.t("common:errors.notFound"));
  } else if (error.response?.status === 500) {
    toast.error(i18n.t("common:errors.serverError"));
  } else if (error.response?.status && error.response.status >= 400) {
    toast.error(errorMessage);
  } else {
    toast.error(i18n.t("common:errors.network"));
  }

  return errorMessage;
};

export const handleApiSuccess = (message: string) => {
  toast.success(message);
};
